/**
 * En que sitio esta corriendo el front: el general (deautopartes.ar) o la tienda propia de una cuenta
 * (pepe.deautopartes.ar). Sin imports a proposito: lo usa http.service, y tienda.service usa http.
 *
 * En local el host siempre es localhost, asi que la tienda se simula con `?tienda=pepe` en la URL
 * (queda en sessionStorage para esa pestaña; `?tienda=` la saca). El back la recibe por el header
 * X-Tienda-Host, que solo acepta en dev.
 */

export const DOMINIO_BASE = 'deautopartes.ar';
export const URL_GENERAL = 'https://' + DOMINIO_BASE;

const HOSTS_PROPIOS = [DOMINIO_BASE, 'www.' + DOMINIO_BASE];
const HOSTS_LOCALES = ['localhost', '127.0.0.1'];
const CLAVE_DEV = 'tiendaDev';

function esLocal(): boolean {
    return HOSTS_LOCALES.includes(window.location.hostname.toLowerCase());
}

function subdominioDev(): string | null {
    try {
        const param = new URLSearchParams(window.location.search).get('tienda');
        if (param !== null) {
            if (param.trim()) sessionStorage.setItem(CLAVE_DEV, param.trim().toLowerCase());
            else sessionStorage.removeItem(CLAVE_DEV);
        }
        return sessionStorage.getItem(CLAVE_DEV);
    } catch (e) {
        return null;
    }
}

/** "pepe.deautopartes.ar" si el front corre en una tienda, o null en el sitio general. */
export function hostDeTienda(): string | null {
    const host = window.location.hostname.toLowerCase();
    if (esLocal()) {
        const sub = subdominioDev();
        return sub ? sub + '.' + DOMINIO_BASE : null;
    }
    if (HOSTS_PROPIOS.includes(host)) return null;
    return host.endsWith('.' + DOMINIO_BASE) ? host : null;
}

/** El header que simula la tienda en desarrollo. En produccion el back usa el Host real. */
export function headerTiendaDev(): string | null {
    return esLocal() ? hostDeTienda() : null;
}

/** URL de la pagina en el sitio general (para lo que no existe en una tienda: panel, admin...). */
export function urlEnGeneral(ruta: string): string {
    if (!esLocal()) return URL_GENERAL + ruta;
    // set y no agregar "&tienda=": si la ruta ya traia ?tienda=pepe, get() lee el primero y
    // seguia en la tienda, redirigiendo en loop.
    const url = new URL(ruta, window.location.origin);
    url.searchParams.set('tienda', '');
    return url.pathname + url.search;
}
